import axios from 'axios';

const documentAPI = {
	getCourseDocument: async (courseId: number, courseUnitId: number): Promise<string> => {
		return axios.get(`/teacher/activityDocument/courseId/${courseId}/courseUnitId/${courseUnitId}`).then(res => res.data);
	},

	getListCourseDocuments: async (): Promise<TeacherCourseWithUnitsDTO[]> => {
		return await axios.get('/teacher/courses', {
		}).then(res => res.data as TeacherCourseWithUnitsDTO[]);
	},
	getStudentLayer: async (studentId: string, activityId: number, type: 'Activity' | 'Assessment'): Promise<string> => {
		return axios.get(`/teacher/studentLayer/${studentId}/activityId/${activityId}/type/${type}`).then(res => res.data);
	},
	getCourseDocumentById: async (documentId: number): Promise<string> => {
		return axios.get(`/teacher/courseDocument/${documentId}`).then(res => res.data);
	},
	getStudentPBADocumentByName: async (studentId: string | undefined, filename: string): Promise<string> => {
		return axios.get(`/teacher/studentpbadocumentbyname/${studentId}/${filename}`).then(res => res.data);
	},
	getStudentCourseUnit: async (courseId: string, studentId: string): Promise<TeacherCourseDTO> => {
		return axios.get(`/teacher/courseunits/${courseId}/${studentId}`, {
		}).then(res => res.data as TeacherCourseDTO);
	},
	postactivitystatus: async (courseActivityId: number, studentId: string, status: string, type: string | undefined, gradeReceived: number | undefined) => {
		const formData = {
			courseActivityId,
			studentId,
			status,
			type,
			gradeReceived,
		};
		return axios.post('/teacher/courseactivitystatus', formData, {
		}).then(res => res.data);
	},
	getStudentExamStudentAnswers: async (studentId: string, courseAssessmentId: number, attemptNumber: number): Promise<TeacherCourseExamStudentAnswerDTO> => {
		return axios.get(`/teacher/courseexam/courseAssessmentId/${courseAssessmentId}/studentId/${studentId}/attemptNumber/${attemptNumber}`, {
		}).then(res => res.data as TeacherCourseExamStudentAnswerDTO);
	},
	postStudentExamGrade: async (data: TeacherCourseExamStudentAnswerDTO): Promise<TeacherCourseExamStudentAnswerDTO> => {
		return axios.post(`/teacher/courseexam/courseAssessmentId/${data.courseAssessmentId}/studentId/${data.studentId}`, data, {

		}).then(res => res.data as TeacherCourseExamStudentAnswerDTO);
	},
	postWorkbookCompletionGrade: async (studentId: string | undefined, courseId: string | undefined, courseUnitId: string | undefined, gradeReceived: number | undefined): Promise<boolean> => {
		return axios.post('/teacher/student/workbookcompletiongrade', { StudentID: studentId, CourseId: courseId, CourseUnitId: courseUnitId, WorkbookCompletionGradeReceived: gradeReceived }, {
		}).then(res => res.data as boolean);
	},
	getStudentWorkSample: async (studentId: string | undefined, courseUnitId: string | undefined): Promise<StudentWorkSampleDTO> => {
		return axios.get(`/teacher/worksample/${courseUnitId}/${studentId}`).then(res => res.data as StudentWorkSampleDTO);
	},
	postStudentWorkSample: async (data: StudentWorkSampleDTO): Promise<StudentWorkSampleDTO> => {
		return axios.post('/teacher/worksample', data)
			.then(res => res.data as StudentWorkSampleDTO);
	},
	getFileWorkSample: async (filename: string): Promise<string> => {
		return await axios.get(`/teacher/worksample/file/${filename}`).then(res =>  res.data as string);
	},
};

export default documentAPI;